export default "__VITE_ASSET__xaMX0JrC__"